<template>
  <div class="wallet-donut">
    <div class="wallet-donut__total">
      <span class="wallet-donut__label">Soma total</span>
      {{ total }}
    </div>
    <ApexChart class="wallet-donut__chart" type="donut" :options="options" :series="series" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { format } from '@/helpers';
  import ApexChart from 'vue-apexcharts';

  export default {
    components: {
      ApexChart,
    },

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      series () {
        const percents = this.coins
          .map(({ total }) => {
            const percent = (total / this.sum) * 100;

            return percent >= 1.5
              ? percent
              : 1.5;
          });

        return percents;
      },

      sum () {
        return this.coins.reduce((sum, { total }) => sum + total, 0);
      },

      total () {
        return format(this.sum / 100);
      },

      options () {
        return {
          legend: {
            show: false,
          },

          stroke: {
            width: 5,
          },

          states: {
            hover: {
              filter: {
                type: 'none',
              },
            },

            active: {
              filter: {
                type: 'none',
              },
            },
          },

          colors: [
            ({ seriesIndex }) => this.coins[seriesIndex].color,
          ],

          chart: {
            sparkline: {
              enabled: true,
            },
          },

          tooltip: {
            theme: false,

            custom: ({ seriesIndex }) => {
              const {
                color,
                total,
                initial,
              } = this.coins[seriesIndex];

              return `<div class="dash-label">
                <span class="dash-label__initial" style="color:${color}">${initial}</span>${format(total / 100)}
              </div>`;
            },
          },

          plotOptions: {
            pie: {
              size: 115,
              expandOnClick: false,
              // customScale: .9,

              donut: {
                labels: {
                  show: false,
                },

                size: '84%',
              },
            },
          },
        };
      },
    },
  };
</script>

<style lang="scss">
  .wallet-donut {
    display: flex;
    position: relative;
    align-items: center;

    path {
      stroke: #26273f;
    }

    &__total {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: #FFF;
      display: flex;
      font-size: 20px;
      font-weight: 300;
      position: absolute;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    &__label {
      margin: 6px 0;
      color: #b2b8c5;
      font-size: 13px;
      line-height: 1.11;
      font-weight: normal;
    }
  }
</style>
